import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiAlertCircle, FiXCircle } from 'react-icons/fi';
import styles from './ToastPopup.module.css';

const iconMap = {
  success: <FiCheckCircle className={styles.iconSuccess} />,
  error: <FiXCircle className={styles.iconError} />,
  alert: <FiAlertCircle className={styles.iconAlert} />
};

const ToastPopup = ({ message, type = 'success', isVisible, onClose }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={`${styles.toast} ${styles[type]}`}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.3 }}
        >
          <div className={styles.iconWrapper}>
            {iconMap[type]}
          </div>
          <div className={styles.message}>{message}</div>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close notification">
            <FiXCircle />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ToastPopup;